import { render, staticRenderFns } from "./Mensajes.vue?vue&type=template&id=b3ad0cde"
import script from "./Mensajes.vue?vue&type=script&lang=js"
export * from "./Mensajes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports